import { Box, Button, Typography, useMediaQuery, useTheme } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import ACTButton from "./ACTButton";
import Timer from "../Timer";
import { AppSelectDropdownWhite } from "./AppSelectDropdownWhite";
import CircularProgress from "@mui/material/CircularProgress";
import AccountSelectInputWhite from "./AccountSelectInputWhite";

const HomePanel = (props) => {
  const { onGenerateQR, sessionData, deeplink, defaultAPIKey } = props;
  const timerRef = useRef();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [updateQrCode, setUpdateQrCode] = useState(false);
  const [accountIdEntered, setAccountIdEntered] = useState("");
  const [selectedAPIKey, setSelectedAPIKey] = useState(defaultAPIKey);
  const onTextEnter = (text) => {
    setAccountIdEntered(text);
  };

  var expTime = sessionData?.expiryTime;

  useEffect(() => {}, []);

  const verifyLocation = () => {};

  const handleQrCodeScanned = () => {
    if (timerRef.current) {
      timerRef.current.stopTimer(); // Stop the timer
    }
  };
  const handleTimerExpire = () => {
    setUpdateQrCode(true);
  };

  const onRefreshQrCode = () => {
    onGenerateQR();
    setUpdateQrCode(false);
  };

  const openInVerifyApp = () => {
    window.location.href = deeplink;
  };

  const [loading, setLoading] = useState(true);

  return (
    <>
      <Box
        sx={{
          marginTop: "4.5rem",
          width: "100%",
        }}
      >

        {!updateQrCode && (
          <>
            <Box
              sx={{
                backgroundColor: "#000000",
                height: "3.5rem",
                width: isMobile ? "82vw" : "19rem",
                padding: "0.5rem",
                borderRadius: "0.5rem",
                gap: "0.75rem",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                marginBottom: "1rem",
                position: "absolute",
                top: "0",
                left: "50%",
                transform: "translateX(-50%)",
              }}
            >
              <AppSelectDropdownWhite
                selectedAPIKey={selectedAPIKey}
                defaultAPIKey={defaultAPIKey}
              />
              <AccountSelectInputWhite textHandler={onTextEnter} />
            </Box>
            {accountIdEntered.length > 0 && (
              <Box
                sx={{
                  width: "16rem",
                  margin: "0 auto 0.5rem auto",
                  position: "absolute",
                  top: "5.5rem",
                  left: "50%",
                  transform: "translateX(-50%)",
                }}
              >
                <ACTButton
                  content="Generate QR Code"
                  onClick={onRefreshQrCode}
                  bgColor="#ffffff"
                  textColor="#000000"
                  hoverColor="#E54F9C"
                  hoverTextColor="#ffffff"
                  border="0.1rem solid #000000"
                  hoverBorder="0.1rem solid #E54F9C"
                />
              </Box>
            )}

            {defaultAPIKey === null ? (
              <Typography
                sx={{
                  maxWidth: "95%",
                  fontSize: "1.3rem",
                  fontWeight: "500",
                  lineHeight: "1.2",
                }}
              >
                Select a <span style={{ color: "#E54F9C" }}>location</span> to
                start
              </Typography>
            ) : (
              <>
                {!accountIdEntered.length > 0 && (
                  <Typography
                    sx={{
                      maxWidth: "90%",
                      fontSize: isMobile ? "1rem" : "1rem",
                      lineHeight: "1.2",
                      fontWeight: "500",
                      margin: isMobile
                        ? "0.25rem auto 0.75rem auto"
                        : "0 auto 0.75rem auto",
                      width: "100%",
                      position: "absolute",
                      top: "6rem",
                      left: "50%",
                      transform: "translateX(-50%)",
                    }}
                  >
                    To continue to play, we need to{" "}
                    <span style={{ color: "#E54F9C" }}>Verify</span> the
                    location of your browser.
                  </Typography>
                )}
                {loading && (
                  <Box
                    sx={{
                      height: isMobile ? "125px" : "155px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      position: "absolute",
                      top: "9rem",
                      left: "50%",
                      transform: "translateX(-50%)",
                    }}
                  >
                    <CircularProgress
                      size="6rem"
                      sx={{
                        color: "#E54F9C",
                      }}
                    />
                  </Box>
                )}
                <img
                  src={sessionData?.qrCode}
                  alt="QR Code"
                  onLoad={() => setLoading(false)}
                  style={{
                    display: loading ? "none" : "flex",
                    width: isMobile ? "125px" : "155px",
                    height: isMobile ? "125px" : "155px",
                    margin: "0 auto",
                    position: "absolute",
                    top: "9rem",
                    left: "50%",
                    transform: "translateX(-50%)",
                  }}
                />
                <Typography
                  sx={{
                    maxWidth: "95%",
                    fontSize: "0.8rem",
                    fontWeight: "500",
                    lineHeight: "1.25",
                    margin: isMobile
                      ? "0.25rem auto 1rem auto"
                      : "0.25rem auto 0 auto",
                    width: "100%",
                    position: "absolute",
                    top: isMobile ? "21rem" : "19.25rem",
                    left: "50%",
                    transform: "translateX(-50%)",
                  }}
                >
                  Scan the QR code using the ACTVerify app.
                </Typography>

                {isMobile && (
                  <Box
                    sx={{
                      width: "17rem",
                      margin: isMobile
                        ? "0.75rem auto 0 auto"
                        : "1.5rem auto 0 auto",
                      position: "absolute",
                      top: "16.75rem",
                      left: "50%",
                      transform: "translateX(-50%)",
                    }}
                  >
                    <ACTButton
                      content="Open in ACTVerify App"
                      onClick={openInVerifyApp}
                      bgColor="#E54F9C"
                      textColor="#ffffff"
                      hoverColor="#b33b78"
                      hoverTextColor="#ffffff"
                      border="0.1rem solid #E54F9C"
                      hoverBorder="0.1rem solid #b33b78"
                    />
                  </Box>
                )}
              </>
            )}
          </>
        )}
      </Box>
      <Box>
        {(sessionData?.expiryTime || accountIdEntered.length > 0) && (
          <Timer
            style={{
              maxWidth: "12.5rem",
              fontSize: "0.9rem",
              fontWeight: "500",
              margin: isMobile ? "0 auto" : "0.25rem auto",
            }}
            ref={timerRef}
            expiryTime={expTime}
            onExpire={handleTimerExpire}
          />
        )}

        {updateQrCode && (
          <Box
            sx={{
              width: "16rem",
              margin: "0 auto",
              position: "absolute",
              top: "10rem",
              left: "50%",
              transform: "translateX(-50%)",
            }}
          >
            <ACTButton
              content="Refresh QR Code"
              onClick={onRefreshQrCode}
              bgColor="#E54F9C"
              textColor="#ffffff"
              hoverColor="#b33b78"
              hoverTextColor="#ffffff"
              border="0.1rem solid #E54F9C"
              hoverBorder="0.1rem solid #b33b78"
            />
          </Box>
        )}
      </Box>
    </>
  );
};

export default HomePanel;
